module.exports = __webpack_public_path__ + "img/2_mil.fa41df59.jpg";